import { isDoctorPortal } from '../isDoctorPortal';
import Constants from 'expo-constants';

export const getBrandAuthConfig = () => {
  const portalConfig = Constants.expoConfig?.extra?.portal_auth0_web;
  const consumerConfig = Constants.expoConfig?.extra?.auth0_web;

  if (isDoctorPortal()) {
    return portalConfig ?? {};
  }

  return consumerConfig ?? {};
};
